

















import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';

@Component({components: {}})
export default class PresentationComment extends Slide {
  get text() {
    return this.section.Comment;
  }
}
